import { showSuccessToast, showErrorToast } from '../../../shared/utils/toastHelper';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../../shared/utils/apiConfig';


const AdminNotifications = () => {
  const navigate = useNavigate();
  const NOTIFICATION_TOPIC = 'all_clients';
    useEffect(() => {
      // Check for admin token (like AdminBanners)
      const storedAdmin = sessionStorage.getItem("adminkhadamat");
      let hasToken = false;
      if (storedAdmin) {
        try {
          const parsed = JSON.parse(storedAdmin);
          if (parsed?.data?.token?.access_token || parsed?.data?.access_token || parsed?.data?.token || parsed?.token) {
            hasToken = true;
          }
        } catch {}
      }
      if (!hasToken) {
        navigate("/admin-login", { replace: true });
      }
    }, [navigate]);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);
    setError(null);
    try {
      await apiClient.post('/admin/dashboard/notifications/send', {
        title,
        body,
        topic: NOTIFICATION_TOPIC,
      });
      setSuccess("تم إرسال الإشعار بنجاح");
      showSuccessToast("تم إرسال الإشعار بنجاح");
    } catch (err) {
      const msg = err.response?.data?.message || err.message || "حدث خطأ أثناء الإرسال";
      setError(msg);
      showErrorToast(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      maxWidth: 700,
      margin: '40px auto',
      padding: 40,
      background: '#fff',
      borderRadius: 16,
      boxShadow: '0 4px 24px #e0e7ef',
      border: '1px solid #e5e7eb',
      minHeight: 420
    }}>
      <h3 style={{
        textAlign: 'center',
        marginBottom: 32,
        fontSize: 22,
        color: '#184194',
        letterSpacing: 1,
        fontWeight: 600
      }}>
        <span style={{ fontSize: 16, color: '#555', fontWeight: 400 }}>ارسال الاشعارات</span>
      </h3>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 24 }}>
          <label htmlFor="title" style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>عنوان الإشعار</label>
          <input
            id="title"
            type="text"
            value={title}
            onChange={e => setTitle(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '14px 12px',
              borderRadius: 8,
              border: '1px solid #cbd5e1',
              fontSize: 16,
              background: '#f9fafb',
              transition: 'border 0.2s',
              outline: 'none'
            }}
          />
        </div>
        <div style={{ marginBottom: 32 }}>
          <label htmlFor="body" style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>محتوى الإشعار</label>
          <textarea
            id="body"
            value={body}
            onChange={e => setBody(e.target.value)}
            required
            rows={6}
            style={{
              width: '100%',
              padding: '14px 12px',
              borderRadius: 8,
              border: '1px solid #cbd5e1',
              fontSize: 16,
              background: '#f9fafb',
              resize: 'vertical',
              minHeight: 120,
              transition: 'border 0.2s',
              outline: 'none'
            }}
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '14px 0',
            background: loading ? '#bfc8e6' : '#184194',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontWeight: 700,
            fontSize: 18,
            letterSpacing: 1,
            boxShadow: '0 2px 8px #e0e7ef',
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'background 0.2s'
          }}
        >
          {loading ? 'جاري الإرسال...' : 'إرسال الإشعار'}
        </button>
      </form>
    </div>
  );
};

export default AdminNotifications;
